module.exports = __webpack_public_path__ + "img/sideboard.38db585e.svg";